import { Component, OnInit, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef, MatDialog } from '@angular/material';
import { ModalStartScreenComponent } from '../modal-start-screen/modal-start-screen.component';

@Component({
  selector: 'app-modal-password-confirmation',
  templateUrl: './modal-password-confirmation.component.html',
  styleUrls: ['./modal-password-confirmation.component.scss']
})
export class ModalPasswordConfirmationComponent implements OnInit {

  email: string;

  constructor(@Inject(MAT_DIALOG_DATA) public data: any,
              public dialogRef: MatDialogRef<ModalPasswordConfirmationComponent>,
              public dialog: MatDialog
              ) { }

  closeDialog() {
    this.dialogRef.close();
  }

  login() {
    const dialogRef = this.dialog.open(ModalStartScreenComponent, {
      width: '835px',
      height: '75vh',
      data: 'login'
    });

    dialogRef.afterClosed().subscribe(result => {
      // console.log('Start screen dialog was closed');
    });
  }

  ngOnInit() {
    this.email = this.data.email;
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/modals/modal-password-confirmation/modal-password-confirmation.component.ts